export const KEY_LEFT = 'from';
export const KEY_RIGHT = 'to';

export const TYPE_INTEGER = 'integer';
export const TYPE_DATE_YEAR = 'date-year';
export const TYPE_DECIMAL = 'decimal';
